module.exports = __webpack_public_path__ + "img/N0 200X200.3554d159.png";